export default "__VITE_ASSET__BZqkkyTO__"